class ConfigPayments {
  configs;

  constructor() {
    try {
      const configJson = document.querySelector("script#paymentsConfig")?.textContent;
      this.configs = JSON.parse(configJson);
      if (!Array.isArray(this.configs)) {
        throw new Error("paymentsConfig Inválido");
      }
    } catch (e) {
      this.configs = [];
    }
  }

  /**
   * 
   * 
   * @param {number|string} gatewayId 
   * @returns {{gateway_id: string|number, sdk_url: string, sdk_public_key: string}}
   */
  getByGateway(gatewayId) {
    return this.configs.find(c => c.gateway_id == gatewayId);
  }

  /**
   * Carrega um script de SDK
   * Podendo adicionar um callback quando necessário
   * 
   * @param {number|string} gatewayId 
   * @param {(e: Event) => void} callback 
   */
  loadSDKScript(gatewayId, callback = null) {
    const gatewayConfig = this.getByGateway(gatewayId);
    if (gatewayConfig != undefined) {
      const script = document.createElement("script");
      script.src = gatewayConfig.sdk_url;
      document.head.appendChild(script);
      if (typeof callback === "function" ) {
        script.addEventListener("load", callback);
      }
    }
  }
}

export const paymentsConfig =  new ConfigPayments();

export const createSelectOptionsForCardForm = (select, installment, total, message) => {
  const option = document.createElement('option');
  if (installment == 0) {
    option.disabled = true;
    option.selected = true;
    option.textContent = 'Selecione';
  } else {
    option.value = installment + "_" + total;
    option.textContent = message;
  }
  select.appendChild(option);
}

export const getCardInfo = (form) => {
  const cardholderName = form.querySelector("input#cardHolderName")?.value;
  const cardNumber = form.querySelector("input#cardNumber")?.value?.replace(/\D/g, '');
  const securityCode = form.querySelector("input#cardSecurityCode")?.value;
  const [ cardExpirationMonth, cardExpirationYear ] = form.querySelector("input#cardExpirationDate")?.value?.split('/');
  return { cardholderName, cardNumber, cardExpirationMonth, cardExpirationYear, securityCode }
}

/**
 * Cria um formulário para submeter os dados de um formulário,
 * sem precisar ter um formulário html pronto
 */
export class VirtualForm {
  #form;
  /**
   * 
   * @param {string} id 
   * @param {string} action 
   * @param {'GET'|'POST'|'PUT'|'DELETE'} method 
   */
  constructor(id, action = "", method = "") {
    this.#form = document.createElement("form");
    this.#form.id = id;
    this.#form.action = action;
    this.#form.method = method;
  }

  /**
   * Adiciona um input hidden ao formulário
   * @param {string} name 
   * @param {string|number} value
   * @param {'hidden'|'submit'|'text'} type
   */
  addInput(name, value, type = 'hidden') {
    const input = document.createElement('input');
    input.type = type;
    input.name = name;
    input.value = value;
    this.#form.appendChild(input);
  }

  getForm() {
    return this.#form;
  }
}